type UseInfoPointPlacementParameters = {
    infoPointElements: HTMLDivElement[];
};

const useInfoPointPlacement = ({ infoPointElements }: UseInfoPointPlacementParameters): void => {
    infoPointElements.forEach((infoPointElement) => {
        const horizontalPositionPercent = Number.parseFloat(infoPointElement.dataset.xCoordinate || '0');
        const verticalPositionPercent = Number.parseFloat(infoPointElement.dataset.yCoordinate || '0');

        infoPointElement.style.left = `${horizontalPositionPercent}%`;
        infoPointElement.style.top = `${verticalPositionPercent}%`;
    });
};

export default useInfoPointPlacement;
